import styled from "@emotion/styled";
import { theme } from "Application";
import { Box } from "Components";

export const Container = styled.div`
    padding: 25px 20px;
`;

export const DataScroll = styled(Box)`
    &::-webkit-scrollbar {
        width: 1px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`;

export const Footer = styled.div``;

export const ButtonGroup = styled.div`
    padding: 30px 0 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: 15px 30px;
    justify-content: center;
    Button {
        width: 100%;
        margin: 0 auto;
        height: 40px;
        border-radius: 5px;
        max-width: 150px;
        background-color: #fcd21d;
        color: #000;
    }
`;

export const StyledDialog = styled.dialog`
    max-width: 400px;
    width: calc(100% - 50px);
    padding: 0;
    background: ${theme.palette.common.white};
    box-shadow: 0 0 5px rgba(101, 110, 119, 0.2);
    border: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    &:focus {
        border: none;
        outline: none;
    }

    &::backdrop {
        background: rgba(224, 228, 232, 0.9);
        animation: 0.4s ease fade;
    }

    &[open] {
        animation: 0.2s linear slidein;
    }

    @keyframes slidein {
        from {
            transform: translate3d(0, 5px, 0) translate(-50%, -50%);
        }
        to {
            transfrom: translate3d(0, 0, 0) translate(-50%, -50%);
        }
    }

    @keyframes fade {
        from {
            opacity: 0.3;
        }
        to {
            opacity: 1;
        }
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fcd21d;
    padding: 12px 20px;
    font: normal normal bold 18px/24px Open Sans;
    letter-spacing: 0px;
    color: #000000;
    font-family: OpenSans-CondBold;
    button {
        width: auto !important;
        height: auto !important;
        min-height: auto;
    }
`;

export const TableInnerData = styled(Box)`
    & > div:nth-of-type(even) {
        background: #f9f9f9;
    }
`;

export const DayHeaderCell = styled(Box)`
    background: #f3f3f3;
    text-align: center;
    padding: 12px;
    margin-bottom: 2px;
`;

export const SlotHeaderCell = styled(Box)`
    background: #f3f3f3;
    text-align: center;
    padding: 12px;
`;

export const StudentNameCell = styled(Box)`
    background: #fff;
    padding: 12px 10px;
    text-decoration: underline;
    font: normal normal normal 12px/16px Open Sans;
    letter-spacing: -0.12px;
    color: #000000;
`;
